import test from "./test/index"; //测试
import ybutton from "./ybutton/index"; //按钮
import ytree from "./ytree/index"; //树

const components = [test, ybutton, ytree];
const install = function (Vue) {
  if (install.installed) return;
  components.map((component) => Vue.component(component.name, component));
};
if (typeof window.Vue !== "undefined" && window.Vue) {
  install(window.Vue);
}
export default {
  install,
  test,
  ybutton,
  ytree
};
